<template class="m-0">
  <b-modal id="new-clase" size="xl" title="Nueva Clase" @ok="crearClase()">
    <b-row>
      <b-col>
        <label for="">Año</label>
        <b-form-select v-model="formClass.x_year_id" :options="yearOptions"></b-form-select>
      </b-col>
      <b-col>
        <label for="">Curso</label>
        <b-form-select v-model="formClass.x_product_template_id" :options="courseOptions"></b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <label for="">Aula</label>
        <b-form-select v-model="formClass.x_room_id" :options="roomOptions"></b-form-select>
      </b-col>
      <b-col>
        <label for="">Docente</label>
        <b-form-select v-model="formClass.x_teacher_id" :options="teacherOptions"></b-form-select>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h5>Horarios</h5>
      </b-col>
    </b-row>
    <b-row v-for="(v, k) in formClass.schedule" :key="k">
      <b-col>
        <label for="">Día</label>
        <b-form-select v-model="formClass.schedule[k].x_day_of_week" :options="dayOptions"></b-form-select>
      </b-col>
      <b-col>
        <label for="">Aula</label>
        <b-form-select v-model="formClass.schedule[k].x_room_id" :options="roomOptions"></b-form-select>
      </b-col>
      <b-col>
        <label for="">Comienzo</label>
        <b-input v-model="formClass.schedule[k].x_start_time"></b-input>
      </b-col>
      <b-col>
        <label for="">Finalización</label>
        <b-input v-model="formClass.schedule[k].x_end_time"></b-input>
      </b-col>
      <b-col>
        <b-button @click="quitarHorario(k)" style="margin-top:30px">Quitar</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        
        <b-button @click="agregarHorario()" style="margin-top:15px">Agregar</b-button>
      </b-col>
    </b-row>
    <template #modal-footer="{ cancel }">
      <b-button @click="cancel">
        Cancelar
      </b-button>
      <b-button @click="guardarClase()">
        Guardar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { ScheduleService } from '@/services/schedule.service'
import { ClassesService } from '@/services/classes.service'
import { CoursesService } from '@/services/courses.service'
import { RoomService } from '@/services/room.service'
import { TeacherService } from '@/services/teacher.service'
// import { EnrollmentsService } from '@/services/enrollments.service'

export default {
  name: 'view-class-enrollments',
  props: [],
  data () {
    return {
      years: this.$store.state.year.list,
      classes: [],
      courses: [],
      rooms: [],
      teachers: [],
      formClass: {
        x_year_id: 13,
        x_product_template_id: 1,
        x_room_id: 1,
        x_teacher_id: 3,
        schedule: [
          { x_room_id: 1, x_day_of_week: 'monday', x_start_time: '07:00', x_end_time: '08:00' }
        ]
      }
    }
  },
  computed: {
    yearOptions () {
      const opts = []
      for (var i = 0; i < this.years.length; i++) {
        opts.push({ value: this.years[i].id, text: this.years[i].x_year })
      }
      return opts
    },
    courseOptions () {
      const opts = []
      for (var i = 0; i < this.courses.length; i++) {
        opts.push({ value: this.courses[i].id, text: this.courses[i].name })
      }
      return opts
    },
    courseObject () {
      const opts = {}
      for (var i = 0; i < this.courses.length; i++) {
        opts[this.courses[i].id] = this.courses[i]
      }
      return opts
    },
    roomOptions () {
      const opts = []
      for (var i = 0; i < this.rooms.length; i++) {
        opts.push({ value: this.rooms[i].id, text: this.rooms[i].x_name })
      }
      return opts
    },
    roomObject () {
      const opts = {}
      for (var i = 0; i < this.rooms.length; i++) {
        opts[this.rooms[i].id] = this.rooms[i]
      }
      return opts
    },
    teacherOptions () {
      const opts = []
      for (var i = 0; i < this.teachers.length; i++) {
        opts.push({ value: this.teachers[i].id, text: this.teachers[i].x_name })
      }
      return opts
    },
    dayOptions () {
      return [
        { value: 'monday', text: 'Lunes' },
        { value: 'tuesday', text: 'Martes' },
        { value: 'wednesday', text: 'Miercoles' },
        { value: 'thursday', text: 'Jueves' },
        { value: 'friday', text: 'Viernes' }
      ]
    },
    dayObject () {
      return {
        monday: 'Lun',
        tuesday: 'Mar',
        wednesday: 'Mie',
        thursday: 'Jue',
        friday: 'Vie'
      }
    }
  },
  async created () {
    this.years = this.$store.state.year.list
    this.year = this.$store.state.year.selected
    this.courses = await CoursesService.list({})
    this.rooms = await RoomService.list({})
    this.teachers = await TeacherService.list({})
    // this.verInscriptosList = await EnrollmentsService.read(this.enrollments_ids, [])
  },
  methods: {
    async eliminarClase (item) {
      console.log(item)
      const schedule = await ScheduleService.list({ x_class_id: item.id })
      console.log(schedule)
      for (let i = 0; i < schedule.length; i++) {
        await ScheduleService.delete(schedule[i].id)
      }
      await ClassesService.delete(item.id)
      this.classes = await ClassesService.list({ x_year_id: this.selectedYear }, { limit: 0, order: 'x_name asc' })
    },
    async guardarClase () {
      console.log(this.courseObject[this.formClass.x_product_template_id])
      const course = this.courseObject[this.formClass.x_product_template_id]
      let name = course.x_short_name + ' '
      let time = this.formClass.schedule[0].x_start_time + '-' + this.formClass.schedule[0].x_end_time
      let days = ''
      for (var i = 0; i < this.formClass.schedule.length; i++) {
        const scheduleItem = this.formClass.schedule[i]
        const scheduleTime = this.formClass.schedule[i].x_start_time + '-' + this.formClass.schedule[i].x_end_time
        if (time !== scheduleTime) {
          name += days + ' ' + time + ' '
          time = scheduleTime
          days = ''
        }
        if (days !== '') {
          days += ','
        }
        days += this.dayObject[scheduleItem.x_day_of_week]
      }
      name += days + ' ' + time
      const newClass = {
        x_year_id: this.formClass.x_year_id,
        x_product_template_id: this.formClass.x_product_template_id,
        x_room_id: this.formClass.x_room_id,
        x_teacher_id: this.formClass.x_teacher_id,
        x_capacity: this.roomObject[this.formClass.x_room_id].x_capacity,
        x_advanced_class: course.x_advanced_class,
        x_name: name
      }
      console.log(newClass)
      try {
        const classId = await ClassesService.create(newClass)
        for (var j = 0; j < this.formClass.schedule.length; j++) {
          const scheduleItem = this.formClass.schedule[j]
          scheduleItem.x_class_id = classId
          await ScheduleService.create(scheduleItem)
        }
      } catch (error) {
        console.log(error)
      }
    },
    quitarHorario (index) {
      this.formClass.schedule.splice(index, 1)
    },
    agregarHorario () {
      this.formClass.schedule.push({ x_room_id: '', x_day_of_week: '', x_start_time: '', x_end_time: '' })
    }
  }
}
</script>

<style lang='scss' scoped>
</style>
